import { FETCH_LANGUAGES, SET_LOCALE } from '@/redux/actions/i18n.actions'

const initialState = {
	locale: 'es',
	loading: false,
	languages: { byId: {}, allIds: [], allIsoCodes: [] }
}

const languages = (state = initialState.languages, action) => {
	switch (action.type) {
		case FETCH_LANGUAGES.SUCCESS:
			return action.payload
				.sort((a, b) => (a.description > b.description ? 1 : -1))
				.reduce(
					(acc, language) => ({
						byId: { ...acc.byId, [language.id]: language },
						allIds: [...acc.allIds, language.id],
						allIsoCodes: [...acc.allIsoCodes, language.isoCode]
					}),
					{ byId: {}, allIds: [], allIsoCodes: [] }
				)
		case FETCH_LANGUAGES.REQUEST:
		case FETCH_LANGUAGES.FAILURE:
			return { byId: {}, allIds: [], allIsoCodes: [] }
		default:
			return state
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_LANGUAGES.REQUEST:
			return true
		case FETCH_LANGUAGES.SUCCESS:
		case FETCH_LANGUAGES.FAILURE:
			return false
		default:
			return state
	}
}

const locale = (state = initialState.locale, action) => {
	switch (action.type) {
		case SET_LOCALE:
			return action.payload

		default:
			return state
	}
}

export default {
	name: 'i18n',
	reducers: {
		languages,
		loading,
		locale
	}
}
